/* eslint-disable */
import { DownOutlined, IdcardOutlined, InfoCircleOutlined, UserOutlined } from '@ant-design/icons'
import { Col, DatePicker, Form, Input, Row, Select, Switch, Tag } from 'antd'
import { EventsCouponUserParams } from 'features/events/api/events-api.service'
import { useGetTickets } from 'features/events/use-cases/get-price-category'
import { useGetUsresCouponList } from 'features/events/use-cases/get-users-coupon'
import { handleKeyAmount, handleKeyDownThree } from 'features/events/utils'
import { FormSectionsSeparator } from 'features/users/components/modals/form-sections-separator'
import { SetStateAction, useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { CouponFormField } from './types'





const AddCouponForm = ({ couponEditData, form, id, setIsSingleUse, isSingleUse }: { couponEditData: any; form: any, id: any, setIsSingleUse: any, isSingleUse: any }) => {
    const { t } = useTranslation();
    const selectRef = useRef<any>(null);
    const [selectOpen, setSelectOpen] = useState(false);

    const initialCategoryIds = useMemo<number[]>(() => {
        if (!couponEditData) return [];
        if (Array.isArray(couponEditData.EventCategoryId)) {
            return couponEditData.EventCategoryId.map((catId: any) => Number(catId));
        }
        if (Array.isArray(couponEditData.event_categoryIds)) {
            return couponEditData.event_categoryIds.map((c: any) => Number(c.CategoryId || c.id || c));
        }
        
return [];
    }, [couponEditData]);

    const tagRender = (props: any) => {
        const { label, value, closable, onClose } = props;
        const isInitial = couponEditData && initialCategoryIds.includes(Number(value));

        return (
            <Tag
                color="default"
                closable={!isInitial && closable}
                onClose={onClose}
                style={{ marginRight: 4, marginTop: 2, marginBottom: 2, display: 'inline-flex', alignItems: 'center' }}
            >
                {label}
            </Tag>
        );
    };

    const valueType = [
        { value: 1, label: 'Flat' },
        { value: 2, label: 'Percent' },
    ];
   
    const [searchText, setSearchText] = useState<EventsCouponUserParams>({
        search_text: "",
        size: 20,
        page: 1,       
        user_ids: couponEditData?.coupon_user_ids
    });


    useEffect(() => {
        if (couponEditData) {
            
            setSearchText({
                search_text: "",
                size: 20,
                page: 1,
                user_ids: couponEditData?.coupon_user_ids
                
            });
        }
    }, [couponEditData]);
    const { data: couponUserData } = useGetUsresCouponList(searchText);
    const [displayCount, setDisplayCount] = useState(10);
    const usersdata = couponUserData?.items || [];

    const visibleUsers = usersdata.slice(0, displayCount);
    const handleScroll = (e: any) => {
        const target = e.target;

        if (
            target.scrollTop + target.offsetHeight >= target.scrollHeight - 5
        ) {
            setDisplayCount((prev) => prev + 10);
        }
    };
    const couponType = [
        { value: "1", label: 'Automatic' },
        { value: "2", label: 'Manual' },
    ];
    const applyForOptions = [
        { value: "EventLevel", label: 'Event Level' },
        { value: "CategoryLevel", label: 'Category Level' },
    ];
    const { data: EventCategoryData } =
        useGetTickets(id || '', { page: 1, size: 200 }, { enabled: !!id });
    const validateValue = (_: any, value: number) => {
        const selectedValueType = form.getFieldValue(CouponFormField.ValueType);
        if (selectedValueType === 2 && value > 100) {

            return Promise.reject(new Error('Value cannot be more than 100 when ValueType is Percent'));
        }

        return Promise.resolve();
    };
    const [couponTypeVal, setCouponTypeVal] = useState(null);
    const handleCouponTypeChange = (value: SetStateAction<null>) => {
        setCouponTypeVal(value);
    };

    const [applyForVal, setApplyForVal] = useState<string | null>(null);
    const handleApplyForChange = (value: string) => {
        setApplyForVal(value);
        if (value !== "CategoryLevel") {
            form.setFieldsValue({
                [CouponFormField.EventCategoryId]: undefined,
            });
        }
    };

    useEffect(() => {
        if (couponEditData) {
            setCouponTypeVal(couponEditData.coupon_type);
            const hasCategories =
                Array.isArray(couponEditData.EventCategoryId) &&
                couponEditData.EventCategoryId.length > 0;
            const val = couponEditData.ApplicableOn || couponEditData.apply_for || (hasCategories ? "CategoryLevel" : "EventLevel");
            setApplyForVal(val);
        } else {
            setApplyForVal(null);
        }
    }, [couponEditData]);

    const handleSearch = (value: string) => {
        if (value.length >= 3) {
            setSearchText({
                ...searchText,
                search_text: value,
                page: 1
            });  // call API
        }
    };

    return (
        <div className='frmscrll'>
            <FormSectionsSeparator title={""}>
                {!couponEditData?.id && <Form.Item<CouponFormField>
                    label={"Coupon Type"}
                    name={CouponFormField.CouponType}
                    rules={[
                        {
                            required: true,
                            // whitespace: true,
                            message: t('validateMessages.custom.nomsg'),
                        },
                    ]}
                >
                    <Select
                        options={couponType}
                        placeholder={"select coupon type"}
                        className='has-prefix-icon'
                        onChange={handleCouponTypeChange}
                        suffixIcon={
                            <>
                                <IdcardOutlined className='prefix-icon' />
                                <DownOutlined className='suffix-icon' />
                            </>
                        }
                    />
                </Form.Item>}
                <Form.Item<CouponFormField>
                    label={"Apply On"}
                    name={CouponFormField.ApplyFor}
                    rules={[
                        {
                            required: true,
                            message: t('validateMessages.custom.nomsg'),
                        },
                    ]}
                >
                    <Select
                        options={applyForOptions}
                        placeholder={"Select Apply On"}
                        className='has-prefix-icon'
                        onChange={handleApplyForChange}
                        disabled={!!couponEditData?.id}
                        suffixIcon={
                            <>
                                <IdcardOutlined className='prefix-icon' />
                                <DownOutlined className='suffix-icon' />
                            </>
                        }
                    />
                </Form.Item>
                {applyForVal === "CategoryLevel" && (
                    <Form.Item
                    className='event_ctgry'    
                    label={
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                <span>Event Category</span>
                                {couponEditData && (
                                    <span
                                        style={{
                                            color: '#1890ff',
                                            cursor: 'pointer',
                                            fontWeight: 500,
                                            fontSize: 12,
                                            marginLeft: 8,
                                        }}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setSelectOpen((prev) => !prev);
                                            setTimeout(() => selectRef.current?.focus(), 50);
                                        }}
                                    >
                                        + Add More Categories
                                    </span>
                                )}
                            </div>
                        }
                        name="EventCategoryId"
                        rules={[
                            {
                                required: true,
                                message: t('validateMessages.custom.nomsg'),
                            },
                        ]}
                    >
                        <Select
                            ref={selectRef}
                            open={selectOpen}
                            onDropdownVisibleChange={(visible) => {
                                if (!couponEditData) {
                                    setSelectOpen(visible);
                                } else if (!visible) {
                                    setSelectOpen(false);
                                }
                            }}
                            showSearch
                            placeholder="Select Category"
                            filterOption={(input, option: any) =>
                                String(option?.searchValue || option?.value || '')
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                            mode="multiple"
                            maxTagCount={5}
                            tagRender={tagRender}
                            onChange={(values: any[]) => {
                                let finalValues = values;

                                if (couponEditData && initialCategoryIds.length > 0) {
                                    const numericValues = values.map((v: any) => Number(v));
                                    const missingInitial = initialCategoryIds.filter((initId) => !numericValues.includes(initId));
                                    if (missingInitial.length > 0) {
                                        finalValues = Array.from(new Set([...values, ...missingInitial]));
                                    }
                                }

                                const allIds = EventCategoryData?.items?.map((item: any) => item.Id) || [];

                                if (finalValues.includes("all")) {
                                    form.setFieldsValue({
                                        EventCategoryId: allIds
                                    });
                                } else {
                                    form.setFieldsValue({
                                        EventCategoryId: finalValues
                                    });
                                }
                            }}
                            options={[
                                { value: "all", label: "Select All", searchValue: "Select All" },
                                ...(EventCategoryData?.items?.map((item: any) => {
                                    const priceType = item.price_type_name ? item.price_type_name : "Normal";
                                    const categoryTitle = `${item.Category} (${priceType})`;
                                    const isStatusTrue = item.Status === true;
                                    const isInitial = Boolean(couponEditData && initialCategoryIds.includes(Number(item.Id)));

                                    return {
                                        value: item.Id,
                                        searchValue: categoryTitle,
                                        disabled: isInitial,
                                        label: (
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%', color: 'inherit' }}>
                                                <span
                                                    style={{
                                                        width: 8,
                                                        height: 8,
                                                        borderRadius: '50%',
                                                        backgroundColor: isStatusTrue ? '#52c41a' : '#ff4d4f',
                                                        display: 'inline-block',
                                                        flexShrink: 0,
                                                    }}
                                                    title={isStatusTrue ? 'Active' : 'Inactive'}
                                                />
                                                <span>{categoryTitle}</span>
                                            </div>
                                        ),
                                    };
                                }) || []),
                            ]}
                        />
                    </Form.Item>
                )}
                <Form.Item<CouponFormField>
                    label={"Coupon Title"}
                    name={CouponFormField.Title}

                    rules={[
                        {
                            required: true,
                            // whitespace: true,
                            message: t('validateMessages.custom.nomsg'),
                        },
                    ]}
                >
                    <Input
                        placeholder={"Title"}
                        prefix={<UserOutlined className='input-prefix-icon' />}
                    />
                </Form.Item>

                {(!couponTypeVal || couponTypeVal != "2") &&
                    <Form.Item<CouponFormField>
                        label={"Prefix"}
                        name={CouponFormField.Prefix}

                        rules={[
                            {
                                required: true,
                                // whitespace: true,
                                message: t('validateMessages.custom.nomsg'),
                            },
                            {
                                min: 2,
                                max: 2,
                                message: 'Prefix must be exactly 2 characters long',
                            },
                        ]}
                    >
                        <Input
                            placeholder={"Prefix"}
                            maxLength={2}
                            disabled={couponEditData?.id}
                        />
                    </Form.Item>}
                <Form.Item name="coupon_user_ids" label="Select Users">
                    <Select
                        mode="multiple"
                        placeholder="Select Users"
                        style={{ width: "100%" }}
                        optionLabelProp="label"
                        showSearch

                        onPopupScroll={handleScroll}
                        dropdownStyle={{ maxHeight: 300, overflow: "auto" }}
                        filterOption={false}
                        onSearch={handleSearch}
                        disabled={couponEditData?.user_ids.length===0}
                        maxTagCount={5}
                        maxTagPlaceholder={(omittedValues) => `+ ${omittedValues.length} more`}
                    >
                        {visibleUsers.map((user: any) => (
                            <Select.Option
                                key={user.id}
                                value={user.id}      
                                label={user.name}    
                            >
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <div style={{ fontWeight: 500 }}>{user.email}</div>
                                    <div style={{ fontSize: 12, color: "#888" }}>
                                        {user.name} | {user.phone}
                                    </div>
                                </div>
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                
                <Form.Item label="Coupon Usage" name="isUsagePerUser" valuePropName="checked">
                    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                        <Switch
                            checked={isSingleUse}
                            disabled={couponEditData}
                            checkedChildren="ON"
                            unCheckedChildren="OFF"
                            style={{
                                backgroundColor: isSingleUse ? "#52c41a" : undefined, // green when ON
                            }}
                            onChange={(checked) => {
                                setIsSingleUse(checked);
                                form.setFieldValue("isUsagePerUser", checked);
                            }}
                        />

                        <span style={{ fontWeight: 500 }}>
                            {isSingleUse ? "Single Use" : "Multiple Use"}
                        </span>

                         
                        <div
                        style={{
                            marginLeft: "auto",   // 🔥 THIS pushes it to right
                            display: "flex",
                            alignItems: "center",
                            gap: 6,
                        }}
                        >
                        <InfoCircleOutlined style={{ color: "#fa8c16" }} />

                        <span style={{ color: "#fa8c16" }}>
                            {isSingleUse
                            ? "Coupon can not be reused by same user."
                            : "Coupon can be reused by same user."}
                        </span>
                        </div>
                        {/* <Tooltip
                            overlayInnerStyle={{
                                backgroundColor: "#f5f5f5",   // gray background
                                color: "#fa8c16",             // orange text
                                fontWeight: 500
                            }}
                            title={
                                <>
                                    {isSingleUse ? (<div>Coupon can not be reused by same user.</div>) :
                                        (<div>Coupon can be reused by same user.</div>)}



                                </>
                            }
                        >
                            <InfoCircleOutlined style={{ color: "#fa8c16", cursor: "pointer" }} />
                        </Tooltip> */}
                    </div>
                </Form.Item>

                {couponEditData?.id &&
                    <Form.Item<CouponFormField>
                        label={"Coupon Code"}
                        name={CouponFormField.couponCode}

                    // rules={[
                    //     {
                    //         required: true,
                    //         // whitespace: true,
                    //         message: t('validateMessages.custom.nomsg'),
                    //     },
                    // ]}
                    >
                        <Input
                            placeholder={""}
                            disabled={couponEditData?.id}
                        />
                    </Form.Item>
                }

                <Row gutter={16} style={{ margin: 0 }}>

                    {/* No of Coupons */}
                    {(!couponEditData?.id && couponTypeVal != "2") && (
                        <Col span={12}>
                            <Form.Item<CouponFormField>
                                label="No of Coupons"
                                name={CouponFormField.NoOfCoupons}
                                rules={[
                                    {
                                        required: true,
                                        message: t('validateMessages.custom.nomsg'),
                                    },
                                ]}
                            >
                                <Input
                                    placeholder="No of coupons"
                                    onKeyDown={handleKeyDownThree}
                                />
                            </Form.Item>
                        </Col>
                    )}

                    {/* Limit Usage */}
                    {!couponEditData?.id && (
                        <Col span={12}>
                            <Form.Item<CouponFormField>
                                label="Limit Usage"
                                name={CouponFormField.Limit}
                                rules={[
                                    {
                                        required: true,
                                        message: t('validateMessages.custom.nomsg'),
                                    },
                                ]}
                            >
                                <Input
                                    placeholder="Limit Usage"
                                    onKeyDown={handleKeyDownThree}
                                />
                            </Form.Item>
                        </Col>
                    )}

                    {/* Value Type */}
                    <Col span={12}>
                        <Form.Item<CouponFormField>
                            label="Value Type"
                            name={CouponFormField.ValueType}
                            rules={[
                                {
                                    required: true,
                                    message: t('validateMessages.custom.nomsg'),
                                },
                            ]}
                        >
                            <Select
                                options={valueType}
                                placeholder="Select Value type"
                                className="has-prefix-icon"
                                suffixIcon={
                                    <>
                                        <IdcardOutlined className="prefix-icon" />
                                        <DownOutlined className="suffix-icon" />
                                    </>
                                }
                            />
                        </Form.Item>
                    </Col>

                    {/* Value */}
                    <Col span={12}>
                        <Form.Item<CouponFormField>
                            label="Value"
                            name={CouponFormField.Value}
                            rules={[
                                {
                                    required: true,
                                    message: t('validateMessages.custom.nomsg'),
                                },
                                {
                                    validator(_, value) {
                                        if (!value) return Promise.resolve();
                                        const stringValue = String(value);
                                        const parsedValue = stringValue.match(/^\d*\.?\d{0,3}$/);

                                        return parsedValue
                                            ? Promise.resolve()
                                            : Promise.reject(
                                                new Error(
                                                    'Please enter a valid numeric value with at most three decimal places'
                                                )
                                            );
                                    },
                                },
                                {
                                    validator: validateValue,
                                },
                            ]}
                        >
                            <Input
                                placeholder="Value"
                                onKeyDown={handleKeyAmount}
                            />
                        </Form.Item>
                    </Col>

                    {/* Start Date */}
                    <Col span={12}>
                        <Form.Item<CouponFormField>
                            label="Start Date"
                            name={CouponFormField.StartDate}
                            rules={[
                                {
                                    required: true,
                                    message: t('validateMessages.custom.nomsg'),
                                },
                            ]}
                        >
                            <DatePicker
                                style={{ width: '100%' }}
                                format="DD-MM-YYYY"
                            />
                        </Form.Item>
                    </Col>

                    {/* End Date */}
                    <Col span={12}>
                        <Form.Item<CouponFormField>
                            label="End Date"
                            name={CouponFormField.EndDate}
                            rules={[
                                {
                                    required: true,
                                    message: t('validateMessages.custom.nomsg'),
                                },
                            ]}
                        >
                            <DatePicker
                                style={{ width: '100%' }}
                                format="DD-MM-YYYY"
                            />
                        </Form.Item>
                    </Col>

                </Row>


            </FormSectionsSeparator>
        </div>
    )
}

export default AddCouponForm;
